import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { UserGroupEdit } from "../userGroup/userGroupEdit";
import { UserGroupUserSaveSuccess } from "../userGroup/userGroupEditUserSaveSuccess";
import { UserGroupListItems } from "ui/Scripts/source/models/userGroup/userGroupListItems";
import { UserGroupPage } from "../userGroup/userGroupPage";
import { UserGroupPageAuthorizationLevels } from "../userGroup/userGroupPageAuthorizationLevels";
import { getApiCall, postApiCall } from "./tokenService";
import { TCodeCompanyCode } from "ui/Scripts/source/models/common/codeCompanyCode";

// #region UserPage
export const getUserGroupPage = (): Promise<UserGroupPage> => {
    return getApiCall("api/usergroup", UserGroupPage);
};

export const getUserGroupPageAuthorizationLevels = (companyId: string): Promise<UserGroupPageAuthorizationLevels> => {
    return getApiCall("api/usergroup/authorizationlevels?id=" + companyId, UserGroupPageAuthorizationLevels);
};

export const getUserGroupListItems = (companyId: string, pageSize: number, page: number, filter: string, authorizationLevels: number[], sortColumn: string, sortOrderIsAsc: boolean,
    ignoreUserGroupCodes: string[] = null): Promise<UserGroupListItems> => {
    return postApiCall("api/usergroup/list", UserGroupListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        authorizationLevels,
        ignoreUserGroupCodes: ignoreUserGroupCodes || []
    }));
};

export const getUserGroupEdit = (companyId: string, userId: string, qrCodeUserGroup: boolean): Promise<UserGroupEdit> => {
    return getApiCall("api/usergroup/edit?id=" + userId + "&companyId=" + companyId + "&qrCodeUserGroup=" + qrCodeUserGroup, UserGroupEdit);
};

export const saveUserGroupEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/usergroup/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeUserGroup = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/usergroup/remove?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const userGroupEditRemoveUsers = (obj: any): Promise<UserGroupUserSaveSuccess> => {
    return postApiCall("api/usergroup/editremoveusers", UserGroupUserSaveSuccess, JSON.stringify(obj));
};

export const userGroupEditAddUsers = (obj: any): Promise<UserGroupUserSaveSuccess> => {
    return postApiCall("api/usergroup/editaddusers", UserGroupUserSaveSuccess, JSON.stringify(obj));
};
// #endregion UserPage

// #region Module properties
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/usergroup/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/usergroup/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module properties

export const getUserGroupListItemsForPermissions = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, groupType: number,
    ignoreUserGroupCodes: string[], requireUserGroupCodes: string[], ignoreQrCodeUserGroups: boolean, requireQrCodeUserGroups: boolean, messageTargetMode: boolean): Promise<UserGroupListItems> => {
    return postApiCall("api/usergroup/listforpermissions", UserGroupListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        groupType: groupType || 0,
        ignoreUserGroupCodes: ignoreUserGroupCodes || [],
        requireUserGroupCodes: requireUserGroupCodes || [],
        ignoreQrCodeUserGroups: ignoreQrCodeUserGroups || false,
        requireQrCodeUserGroups: requireQrCodeUserGroups || false,
        messageTargetMode: messageTargetMode || false
    }));
};

export const getUserGroupListItemsForUser = (companyIds: string[], pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean,
    ignoreUserGroups: TCodeCompanyCode[] = null, requireUserGroups: TCodeCompanyCode[] = null, ignoreQrCodeUserGroups: boolean = false, requireQrCodeUserGroups: boolean = false): Promise<UserGroupListItems> => {
    return postApiCall("api/usergroup/listforuser", UserGroupListItems, JSON.stringify({
        companyIds,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserGroups: ignoreUserGroups || [],
        requireUserGroups: requireUserGroups || [],
        ignoreQrCodeUserGroups: ignoreQrCodeUserGroups || false,
        requireQrCodeUserGroups: requireQrCodeUserGroups || false,
    }));
};
